var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-5"},[_c('v-col',{attrs:{"lg":"12"}},[_c('tabla',{attrs:{"Titulo":_vm.title,"Cabecera":_vm.cabecera,"Items":_vm.Items,"loading":_vm.loader,"Excel":false,"Crear":true},on:{"loadSuscripcionesFunction":_vm.loadSuscripcionesFunction}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }